import { Accordion, Container, Title } from "@mantine/core";
import classes from "../styles/QuestionsAndAnswers.module.css";


export function QuestionsAndAnswers() {
  const data = [
    {
      id: 1,
      Question: "האם יש צורך להוריד את האפליקציה?",
      Answer:
        "אין חובה! QuickTor נגישה מכל מקום ופועלת בצורה מלאה דרך הדפדפן ללא צורך בהורדה, אך למי שמעוניין — ישנה אפשרות מלאה להורדת האפליקציה מחנויות האפליקציות (App Store ו-Google Play) לגישה מהירה ונוחה עוד יותר.",
      value: "1",
    },
    {
      id: 2,
      Question: "למי מותאמת האפליקציה?",
      Answer:
        "האפליקציה מתאימה לכל בעל עסק שזקוק לניהול יומן חכם והורדת העומס הכבד מניהול התורים ופגישות ידנית עם לקוחות באופן קבוע",
      value: "2",
    },
    {
      id: 3,
      Question: "האם יש גישה ליומני עובדים?",
      Answer:
        "מערכת Quick Tor לניהול התורים, מספקת אופציה שניתן להגדיר יומן של כל עובד ספציפי עם שעות עבודה וימים של העובד ולנהל כרטיסייה של כל עובד",
      value: "3",
    },
    {
      id: 4,
      Question: "האם רק הלקוחות שלי יכולים לקבוע תור?",
      Answer:
        "ממש לא! באפשרותך לקבוע עבורם מהיומן האישי שלך ויותר מזה, קיימת אופציה לבחירתך שהלקוחות לא יוכלו לקבוע תורים בעצמם כלל!",
      value: "4",
    },
    {
      id: 5,
      Question: "האם יש רשימת המתנה?",
      Answer:
        "וודאי! המערכת מגדירה באופן אוטומטי רשימות המתנה כאשר ישנם תורים שכבר נתפסו, על מנת לוודא שהיומן תמיד יהיה מלא ושלא יהיו חורים ביומן. מיד לאחר שתור בוטל על ידי לקוח או על ידך, תישלח מיד התראה לאחד הלקוחות מרשימת ההמתנה שיש התאמה איתו לפי הטווח שעות שהוא בחר, אם התור שבוטל עונה על הטווח זמנים שבחר הלקוח, יקבל מיד התראה.",
      value: "5",
    },
    {
      id: 6,
      Question: "האם ניתן לבקש להוסיף פיצ'רים ספציפיים?",
      Answer:
        "לחלוטין כן! בעלים של המערכת QuickTor הינו גם המפתח של האפליקציה, כך שאינו תלוי באף גורם צד שלישי, ובנוסף כל באג או תקלה תמיד יהיה עבורכם אבא ואמא שידאג מיד לטפל בכם לכל הצעה או בעיה.",
      value: "6",
    },
    {
      id: 7,
      Question: "האם יש אופציה להגדיר כמה סוגי שירותים שונים?",
      Answer:
        "בטח! ניתן להוסיף כמה שאתם צריכים סוגי שירותים שונים ללא כל הגבלה.",
      value: "7",
    },
  ];
  return (
    <Container size="sm" className={classes.wrapper}>
      <Title order={2} ta="center" className={classes.title}>
        שאלות נפוצות
      </Title>
      {data?.map((items) => (
        <Accordion variant="contained">
          <Accordion.Item className={classes.item} value={items.value}>
            <Title order={3}>
              <Accordion.Control>{items.Question}</Accordion.Control>
            </Title>
            <Accordion.Panel>{items.Answer}</Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      ))}
    </Container>
  );
}
